import Component from 'gia/Component'
import eventbus from 'gia/eventbus';
import stage from '../components/stage'
import renderer from '../components/render'
import _each from 'lodash.foreach'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

import Draggable from 'gsap/Draggable.js'
gsap.registerPlugin(Draggable)

import { MotionPathPlugin } from 'gsap/MotionPathPlugin.js'
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin.js'
gsap.registerPlugin(MotionPathPlugin, DrawSVGPlugin);
import { SplitText } from 'gsap/SplitText.js'
import { log } from 'handlebars';
gsap.registerPlugin(SplitText);


class Boxes extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.html = $('html')
    this.menu = $('.menu')
    this.element = element
    this.el = $(element)
    this.i = 0


    this.ref = {
      title: [],
      card: [],
      cardbottom: [],
      words: [],
      tech: [],
      letter: [],
      wireless: null,
      spiral: null,
      man: null,
      chart: null,
      doc: null,
      heart: null,
      buttons: null,
      people: null,
      cube: null,
      filter: null,
      percent: null,
      counter: null,
      randcounter: null,
      rand: null
    //   service: []
    }

  }

  mount() {
    
    
    $('.box').on('click', (e) => {

      e.preventDefault()

      if (!$(e.currentTarget).hasClass('is-active')) {
        $('.box.is-active').removeClass('is-active')
        $(e.currentTarget).addClass('is-active')
      } else {
        $('.box.is-active').removeClass('is-active')
      }


    })

   
    this.ref.title.forEach((item, i) => {

        const title = new SplitText(item, {
            type: "words",
            wordsClass: 'word'
        })

        title.words.forEach((item, i) => {
            item.style = `--word-index: ${i}`
        })


        //$(item).addClass('visible')

        ScrollTrigger.create({
          trigger: item,
          start: "top bottom",
          onEnter: ({progress, direction, isActive}) => {
            item.classList.add("visible")
          },
          once: true
        });


    })
      gsap.to('.loupe1', {
          strokeDashoffset: -300,
          duration: 7,
          repeat: -1,
          ease: 'linear'
      })
      gsap.to('.loupe2', {
          strokeDashoffset: -300,
          duration: 7,
          repeat: -1,
          ease: 'linear'
      })

    

    this.ref.words.forEach((item, i) => {

      const title = new SplitText(item, {
        type: "words",
        wordsClass: 'word'
      })

      title.words.forEach((item, i) => {
        item.style = `--word-index: ${i}`
      })

    })

    this.ref.tech.forEach((item, i) => {

      const title = new SplitText(item, {
        type: "words",
        wordsClass: 'word'
      })

      title.words.forEach((item, i) => {
        item.classList.add (`word--${i}`)
      })

    })

    this.ref.letter.forEach((item, i) => {

      const title = new SplitText(item, {
        type: "chars",
        charsClass: "char"
      })

      title.chars.forEach((item, i) => {
        item.style = `--char-index: ${i}`
      })
      title.words.forEach((item, i) => {
        item.style = `--word-index: ${i}`
      })


     


    })

    ScrollTrigger.create({
        trigger: this.ref.percent,
        start: "bottom bottom",
        onEnter: ({
            progress,
            direction,
            isActive
        }) => {

            this.d1 = [0]
            this.d2 = [50]
            this.d2.roundProps = "0";
            this.d2.onUpdate = this.update.bind(this);

            gsap.to(this.d1, 1, this.d2)


        },

        onLeaveBack: ({
            progress,
            direction,
            isActive
        }) => {

            this.b1 = [100]
            this.b2 = [0]
            this.b2.roundProps = "0";
            this.b2.onUpdate = this.updateB.bind(this);

            gsap.to(this.b1, .78, this.b2)


        }

    });

    


    this.ref.card.forEach((item, i) => {
        
     

      ScrollTrigger.create({
          trigger: item,
          start: "top bottom",
          onEnter: ({progress, direction, isActive}) => {
            item.classList.remove("is-first")
            item.classList.add("inview")
          },
          once: true
        });
    });

    this.ref.cardbottom.forEach((item, i) => {

      ScrollTrigger.create({
        trigger: item,
        start: "bottom bottom",
        onEnter: ({
          progress,
          direction,
          isActive
        }) => {
          item.classList.add("inview")
        },
        once: true
      });
    });

        var doc = gsap.timeline({
            repeat: 5,
            scrollTrigger: {

                trigger: this.ref.doc,
                scrub: true
            }
        });
        doc.add(gsap.to(".line1", {
            duration: .5,
            opacity: .1
        }), 0)
        doc.add(gsap.to(".line2", {
            duration: .5,
            opacity: .1
        }), .2)
        doc.add(gsap.to(".line3", {
            duration: .5,
            opacity: .1
        }), .4)
        doc.add(gsap.to(".line1", {
            duration: .5,
            opacity: 1
        }), .6)
        doc.add(gsap.to(".line2", {
            duration: .5,
            opacity: 1
        }), .8)
        doc.add(gsap.to(".line3", {
            duration: .5,
            opacity: 1
        }), 1)



    var cube = gsap.timeline({
        repeat: -1,
        repeatDelay: 0
    });
    cube.add(gsap.fromTo(".svg-cube", {
        xPercent: -200,
        opacity: 0,
        ease: 'power4.out',

        transformOrigin: 'center'
    }, {
        xPercent: 0,
        opacity: 1,

        duration: .17
    }), 0)
    cube.add(gsap.fromTo("#deviation", {
        attr: {
            "stdDeviation": "50 0"
        }
    }, {
        attr: {
            "stdDeviation": "0 0"
        },
        duration: .17,
        ease: 'power4.out'
    }), 0)

    cube.add(gsap.fromTo(".svg-cube", {
        xPercent: 0,
        opacity: 1,

        transformOrigin: 'center'
    }, {
        xPercent: 200,
        opacity: 0,
        ease: 'power4.in',

        duration: .17
    }), 4)
    cube.add(gsap.fromTo("#deviation", {
        attr: {
            "stdDeviation": "0 0"
        }
    }, {
        attr: {
            "stdDeviation": "50 0"

        },
        ease: 'power4.in',
        duration: .17
    }), 4)


    cube.add(gsap.fromTo(".svg-tick", {

        opacity: 0,
        scaleX: 0,
        scaleY: 0,
        transformOrigin: 'center'
    }, {
        opacity: 1,
        scaleX: 1,
        scaleY: 1,
        transformOrigin: 'center',
        ease: 'power4.out',
        duration: .17
    }), .2)


    cube.add(gsap.fromTo(".svg-tick", {

        xPercent: 0,
        scaleX: 1,
        scaleY: 1,
        opacity: 1,
        transformOrigin: 'center'
    }, {
        //xPercent: 500,
        transformOrigin: 'center',
        opacity: 0,
        scaleX: 0,
        scaleY: 0,
        ease: 'power4.in',
        duration: .17
    }), 3.9)



    let targets = gsap.utils.toArray(".clip-line");
    targets.forEach((item, i) => {
        gsap.set(item, {drawSVG: "0"});
    });

    let targets2 = gsap.utils.toArray(".clip-line2");
    targets2.forEach((item, i) => {
      gsap.set(item, {
        drawSVG: "100%"
      });
    });

        ScrollTrigger.create({
          trigger: this.ref.wireless,
          start: "bottom bottom",
          onEnter: ({progress, direction, isActive}) => {
            targets.forEach((item, i) => {
                gsap.fromTo(item, {drawSVG: "0"}, {duration: .5, drawSVG: "100%", delay: i*0.3, ease: 'expo.out'});
            });

            targets2.forEach((item, i) => {
              gsap.fromTo(item, {
                drawSVG: "100% 100%"
              }, {
                duration: .5,
                drawSVG: "0 100%",
                delay: i * 0.3,
                ease: 'expo.out'
              });
            });
          },
          once: true
          
        });

       

       



          
          
        

      
      
        
       
        
var filter = gsap.timeline({
  
  paused: true
});

filter.add(gsap.fromTo('.card__content--filter .line', {
  yPercent: 2000,
  opacity: 1,
  filter: "blur(30px)"
}, {
  yPercent: 0,
  filter: "blur(0px)",
  opacity: 1,
  duration: 1.2,
  stagger: .067,
  ease: 'power4.out'
}),0)



gsap.set('.card__content--filter .line', {
      yPercent: 2000,
      opacity: 1,
      filter: "blur(30px)"
    })

ScrollTrigger.create({
  trigger: this.ref.filter,
  start: "bottom bottom",
  onEnter: ({
    progress,
    direction,
    isActive
  }) => {
    
    filter.play()
    
  },
  once: true

});




        




            const pencil = gsap.timeline({
              paused: true
            })

            pencil.add(
              gsap.fromTo("#clip-line1", {
                drawSVG: "0"
              }, {
                duration: 1,
                drawSVG: "100%"
              }),0
            )

            pencil.add(
              gsap.fromTo("#clip-line4", {
                drawSVG: "0"
              }, {
                duration: 1,
                drawSVG: "100%"
              }), 0
            )

            const pencil1 = gsap.timeline({
              paused: true
            })

            pencil1.add(
              gsap.fromTo("#clip-line2", {
                drawSVG: "0"
              }, {
                duration: 1,
                drawSVG: "100%"
              }), 0
            )

            pencil1.add(
              gsap.fromTo("#clip-line5", {
                drawSVG: "0"
              }, {
                duration: 1,
                drawSVG: "100%"
              }), 0
            )

            const pencil2 = gsap.timeline({
              paused: true
            })

            pencil2.add(
              gsap.fromTo("#clip-line3", {
                drawSVG: "0"
              }, {
                duration: 1,
                drawSVG: "100%"
              }), 0
            )

            pencil2.add(
              gsap.fromTo("#clip-line6", {
                drawSVG: "0"
              }, {
                duration: 1,
                drawSVG: "100%"
              }), 0
            )

          
          //let x11 = 0
           const but1 = Draggable.create("#but1", {
             type: "x",
             bounds: "#bound1",

              onPress: () => {
                pencil.progress(1)
                const pr = gsap.getProperty("#but1", "x")
                const pos = gsap.utils.mapRange(59, -3, 0, 1, pr)

                gsap.to('.clip-line3', {
                  opacity: 1,
                  duration:.2
                })
                console.log(pos);
                
                gsap.to(pencil, {
                  progress: pos,
                  duration: .3,
                  ease: "none"
                });
              },
             
               onRelease: () => {
                 gsap.to(pencil, {
                   progress: 1,
                   duration: .3,
                   ease: "none"
                 });
                 const pr = gsap.getProperty("#but1", "x")
                 x1 = pr

                 gsap.to('.clip-line3', {
                   opacity: 0,
                   duration: .2
                 })
               }
               ,
               onDrag: ()=> {
                  const pr = gsap.getProperty("#but1", "x") 
                  const pos = gsap.utils.mapRange( 59, -3, 0, 1, pr )
                  
                  pencil.progress(pos)

                  
               }
           });
           


           const but2 = Draggable.create("#but2", {
             type: "x",
             bounds: "#bound2",
             
               onPress: () => {
                   const pr = gsap.getProperty("#but2", "x")
                   const pos = gsap.utils.mapRange(59, -3, 0, 1, pr)

                   pencil1.progress(1)
                   gsap.to(pencil1, {
                     progress: pos,
                     duration: .3,
                     ease: "none"
                   });

                   gsap.to('.clip-line3', {
                     opacity: 1,
                     duration: .2
                   })
                 },

                 onRelease: () => {
                   gsap.to(pencil1, {
                     progress: 1,
                     duration: .3,
                     ease: "none"
                   });
                   const pr = gsap.getProperty("#but2", "x")
                   x2 = pr

                   gsap.to('.clip-line3', {
                     opacity: 0,
                     duration: .2
                   })
                 },
                 onDrag: () => {
                   const pr = gsap.getProperty("#but2", "x")
                   const pos = gsap.utils.mapRange(59, -3, 0, 1, pr)

                   pencil1.progress(pos)


                 }
           });

           const but3 = Draggable.create("#but3", {
             type: "x",
             bounds: "#bound3",
               
                 onPress: () => {
                     const pr = gsap.getProperty("#but3", "x")
                     const pos = gsap.utils.mapRange(59, -3, 0, 1, pr)

                     pencil2.progress(1)
                     gsap.to(pencil2, {
                       progress: pos,
                       duration: .3,
                       ease: "none"
                     });

                     gsap.to('.clip-line3', {
                       opacity: 1,
                       duration: .2
                     })
                   },

                   onRelease: () => {
                     gsap.to(pencil2, {
                       progress: 1,
                       duration: .3,
                       ease: "none"
                     });
                     const pr = gsap.getProperty("#but3", "x")
                     x3 = pr

                     gsap.to('.clip-line3', {
                       opacity: 0,
                       duration: .2
                     })
                   },
                   onDrag: () => {
                     const pr = gsap.getProperty("#but3", "x")
                     const pos = gsap.utils.mapRange(59, -3, 0, 1, pr)

                     pencil2.progress(pos)


                   }
           });




        //  buttons.add(gsap.fromTo(".but1", {
        //    x: 0
        //  }, {
        //    duration: .75,
        //    x: 50,
        //    ease: 'linear'
        //  }), 0)
        //  buttons.add(gsap.fromTo(".but3", {
        //    x: 0
        //  }, {
        //    duration: 1,
        //    x: 50,
        //    ease: 'linear'
        //  }), 0)
        //  buttons.add(gsap.fromTo(".but2", {
        //    x: 0
        //  }, {
        //    duration: 1.3,
        //    x: 50,
        //    ease: 'linear'
        //  }), 0)
          
  
         
         
        
                

   

        
    
}


updateText(){
  var theLetters = "abcdefghijklmnopqrstuvwxyz#%&^+=-"; //You can customize what letters it will cycle through
  var ctnt = this.errortext; // Your text goes here
  var speed = 30; // ms per frame
  var increment = 3; // frames per step. Must be >2


  var clen = ctnt.length;
  var si = 0;
  var stri = 0;
  var block = "";
  var fixed = "";
  
  (function rustle(i) {
    setTimeout( ()=>{
      if (--i) {
        rustle(i);
      }
      nextFrame(i);
      si = si + 1;
    }, speed);
  })(clen * increment + 1);

   const nextFrame = (pos) => {
    for (var i = 0; i < clen - stri; i++) {
      //Random number
      var num = Math.floor(theLetters.length * Math.random());
      //Get random letter
      var letter = theLetters.charAt(num);
      block = block + letter;
    }
    if (si == (increment - 1)) {
      stri++;
    }
    if (si == increment) {
      // Add a letter; 
      // every speed*10 ms
      fixed = fixed + ctnt.charAt(stri - 1);
      si = 0;
    }
    $(this.ref.rand).html(fixed + block);
    block = "";
  }
}

      update() {
        const R = (x) => {
          const X = this.d1[x] < 10 ? '0' : this.d1[x] < 100 ? '' : '';
          return X + this.d1[x]
        };

        this.ref.counter.innerHTML = R(0) + "%";
      };

      updateB() {
        const R = (x) => {
          const X = this.b1[x] < 10 ? '0' : this.b1[x] < 100 ? '' : '';
          return X + this.b1[x]
        };

        this.ref.counter.innerHTML = R(0) + "%";
      };

  unmount() {




  }


}

module.exports = Boxes
 